import { createAction } from 'redux-actions';

export const NAMES = {
  PLAYBACK_MODULE_LOADED: 'CLIENT.MOBILE.PLAYBACK_MODULE.LOADED',
};
export const playbackModuleLoaded = createAction(NAMES.PLAYBACK_MODULE_LOADED);
